module.exports = __webpack_public_path__ + "static/media/back-seguro-celular-0.fedb8a24.jpg";